import React, { useEffect, useState } from 'react'
import URL from '../constants/ServerUrl'
import axios from 'axios'
import { useSearchParams  } from 'react-router-dom'
import { NepaliDatePicker } from "nepali-datepicker-reactjs"
import { convertDateToAD, convertDateToBS } from '../utils/convertDate'
import { formatDateInBS } from '../utils/formatDate'
import SkeletonLoader from './Skeletos'



const Ledger = ({ route }) => {
  // FOR DATE PICKER
  const savedDate = convertDateToBS(new Date())
  const [startDate, setStartDate] = useState(convertDateToBS(Date.now() - 30 * 24 * 60 * 60 * 1000))
  const [endDate, setEndDate] = useState(convertDateToBS(Date.now()))
  const [isPickerShow1, setIsPickerShow1] = useState(false)
  const [isPickerShow2, setIsPickerShow2] = useState(false)
  const [startDateString, setStartDateString] = useState("");
  const [endDateString, setEndDateString] = useState("");
  const [tableData, setTableData] = useState([])
  const [farmerData, setFarmerData] = useState([])
  const [farmerName, setFarmerName] = useState('No Farmer')
  const [farmerId, setFarmerId] = useState(null)
  const [remainingBalance, setRemainingBalance] = useState(0)
  const [previousBalanceRow, setPreviousBalanceRow] = useState(['Prev Balance', 0, 0, 'Purano Baki'])
  const [loading, setLoading] = useState(false)
  const [searchParams] = useSearchParams();
  const username = searchParams.get('username');
  const token = localStorage.getItem("dairy-token")
  
  // FOR SEARCH BOX
  const [search, setSearch] = useState('')
  const [focus, setFocus] = useState(false)
  const [filteredTableData, setFilteredTableData] = useState([])
  const [filteredFarmers, setFilteredFarmers] = useState([]);

  // FOR TABLE
  const tableHead = React.useMemo(() => [
    { label: 'Date', flex: 0.25 },
    { label: 'Credit', flex: 0.25 },
    { label: 'Debit', flex: 0.25 },
    { label: 'Remarks', flex: 0.25 },
  ], [])

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    if (e.target.value === '') {
      setFarmerId(null);
      setFarmerName('No Farmer');
      setRemainingBalance(0);
      setFocus(false);
    } else {
      setFocus(true);
    }
  };

 
  const fetchAllFarmers = async () => {
    try {
      const res = await axios.get(`${URL}admin/${username}/farmer`,{
        Authorization: `Bearer ${token}`,
      })
      setFarmerData(res.data)
      // console.log(res.data);
    }
    catch(err)
    {
      console.log(err)
    }
  }

  useEffect(() => {
    try {
      if (username) {
        fetchAllFarmers()
      }
    } catch (error) {
      console.log(error)
    }
  }, [])

  useEffect(() => {
    if (filteredTableData.length > 0)
    {
      const newPreviousBalanceRow = previousBalanceRow
      const totalCredit = filteredTableData.slice(0).reduce((acc, item) => acc + item[3], 0);
      const totalDebit = filteredTableData.slice(0).reduce((acc, item) => acc + item[4], 0);
      const totalBalance = totalCredit - totalDebit + filteredTableData[0][1]

      if (filteredTableData[0][1] >= 0) newPreviousBalanceRow[1] = filteredTableData[0][1]
      else newPreviousBalanceRow[1] = 0
      if (filteredTableData[0][1] < 0) newPreviousBalanceRow[2] = filteredTableData[0][1]
      else newPreviousBalanceRow[2] = 0

      setPreviousBalanceRow(newPreviousBalanceRow)
      setRemainingBalance(totalBalance)
    }
    else
    {
      makePreviousBalanceZero()
    }
  }, [filteredTableData])

  useEffect(() => {
    if (search !== '') {
      fetchLedger()
    }
    else
    {
      makePreviousBalanceZero()
    }

  }, [search, startDate, endDate])

  useEffect(() => {
    setFilteredTableData(tableData.filter((row) => row[0] == farmerId));
  }, [tableData])

  useEffect(() => {
    const searchLower = search.toLowerCase();
    const filtered = farmerData.filter(({ farmerName, farmerId }) => {
      return farmerName.toLowerCase().includes(searchLower) || farmerId.toString().includes(searchLower);
    });
    setFilteredFarmers(filtered);
  }, [search, farmerData]);

  const fetchLedger = async () => {
    try {
      if (username) {
        let startAD=convertDateToAD(startDate);
        let endAD=convertDateToAD(endDate)
        setLoading(true)
        const ledger = await axios.get(
            `${URL}admin/${username}/ledger/${farmerId}?startDate=${startAD}&endDate=${endAD}`,{
                Authorization: `Bearer ${token}`,
            }
        )
        console.log(ledger.data);
        const ledgerArray = ledger.data.map((ledger) => [
          ledger.farmerId,
          ledger.previousBalance,
          formatDateInBS(ledger.date),
          ledger.credit,
          ledger.debit,
          ledger.remarks,
        ])
        setLoading(false)
        setTableData(ledgerArray)
      }
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
  }

  const makePreviousBalanceZero = () => {
      setRemainingBalance(0)
      const newPreviousBalanceRow = previousBalanceRow
      newPreviousBalanceRow[1] = 0
      newPreviousBalanceRow[2] = 0
      setPreviousBalanceRow(newPreviousBalanceRow)
      setRemainingBalance(0)
  }

  useEffect(() => {
    const nepalDate = String(startDate)
    setStartDateString(nepalDate)
  }, [startDate]);

  useEffect(() => {
    const nepalDate = String(endDate)
    setEndDateString(nepalDate)
  }, [endDate]);

  const showPicker1 = () => {
    setIsPickerShow1(true)
  }
  const showPicker2 = () => {
    setIsPickerShow2(true)
  }

  const onChangeStart = ( value) => {

    setStartDate(value)
  }

  const onChangeEnd = ( value) => {

    setEndDate(value)
  }

  return (
    <div className='container mx-auto p-4'>
      {/* Search Input */}
      <input
        className='w-full p-2 border border-gray-300 rounded-md focus:border-blue-500 focus:outline-none'
        placeholder='Search by id or name'
        type='text'
        onChange={handleSearchChange}
        value={search}
      />

      {/* Search Results */}
      {focus && (
        <div className='mt-2'>
          {filteredFarmers.map((item) => (
            <button
              key={item._id}
              className='flex items-center justify-between p-2 border-b border-gray-200 hover:bg-gray-100'
              onClick={() => {
                setFarmerId(item.farmerId);
                setFarmerName(item.farmerName);
                setSearch(item.farmerName);
                setFocus(false);
              }}
            >
              <div>{item.farmerId}</div>
              <div>{item.farmerName}</div>
            </button>
          ))}
        </div>
      )}

      {!focus && (
        <>
          {/* Date Picker Section */}
          <div className='mt-4'>
            <div className='flex items-center justify-between'>
              <div>
                <div className='font-semibold text-gray-700'>From</div>
                {isPickerShow1 ? (
                  <NepaliDatePicker
                    inputClassName='form-control'
                    className='form-control border rounded-md p-2 focus:outline-none focus:border-blue-500'
                    value={startDate}
                    onChange={onChangeStart}
                    options={{ calenderLocale: "en", valueLocale: "en" }}
                  />
                ) : (
                  <button
                    className='mt-1 text-blue-500 hover:text-blue-600'
                    onClick={showPicker1}
                  >
                    {startDateString}
                  </button>
                )}
              </div>
              <div>
                <div className='font-semibold text-gray-700'>To</div>
                {isPickerShow2 ? (
                  <NepaliDatePicker
                    inputClassName='form-control'
                    className='form-control border rounded-md p-2 focus:outline-none focus:border-blue-500'
                    value={endDate}
                    onChange={onChangeEnd}
                    options={{ calenderLocale: "en", valueLocale: "en" }}
                  />
                ) : (
                  <button
                    className='mt-1 text-blue-500 hover:text-blue-600'
                    onClick={showPicker2}
                  >
                    {endDateString}
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* Farmer Details */}
          <div className='mt-4 flex flex-row justify-between items-center'>
            <div>
              <div className='text-lg font-semibold text-gray-700'>
                Id: {farmerId}
              </div>
              <div className='text-lg font-semibold text-gray-700'>
                {farmerName}
              </div>
            </div>
            <div>
              <div className=' font-semibold flex flex-row'>
                <div>{previousBalanceRow[0]} : </div>
                <div>Rs {previousBalanceRow[1].toFixed(2)}</div>
              </div>

              <div className='font-semibold text-gray-700 flex flex-row'>
                <div>Remaining Balance : </div>
                <div>Rs {remainingBalance.toFixed(2)}</div>
              </div>
            </div>
          </div>

          {/* Table Headers */}
          <div className='mt-4'>
            <table className='w-full border-collapse border border-gray-300'>
              <tbody>
                {tableHead.map((header, index) => (
                  <th key={index} className='hover:bg-gray-100'>
                    {header.label}
                  </th>
                ))}
              </tbody>
            </table>
          </div>

          {/* Balance and Ledger */}

          {/* Loading State */}
          {loading && (
            <div className='mt-4'>
              <SkeletonLoader />
            </div>
          )}

          {/* No Search Result */}
          {!loading && search === "" && (
            <div className='mt-4 text-gray-600'>Please Search by Id</div>
          )}

          {/* No Ledger Found */}
          {!loading && search !== "" && filteredTableData.length === 0 && (
            <div className='mt-4 text-red-500'>No Ledger Found</div>
          )}

          {/* Ledger Table */}
          {!loading && search !== "" && filteredTableData.length > 0 && (
            <div className='mt-4'>
              <table className='w-full border-collapse border border-gray-300'>
                <tbody>
                  {filteredTableData.map((rowData, index) => (
                    <tr key={index} className='hover:bg-gray-100'>
                      {rowData.slice(2).map((cellData, cellIndex) => (
                        <td
                          key={cellIndex}
                          className='p-2 border border-gray-300'
                        >
                          {cellData}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}
    </div>
  );
}



export default Ledger